import gql from 'graphql-tag';

/**
 * Data of the block project-appointment-notes ("Besonderheiten bei Terminierung", tab Montage):
 * `technicalReview.appointmentNotes`. Read through `Project.blocks.appointmentNotes`, which checks
 * the block's read permission.
 */
export const PROJECT_APPOINTMENT_NOTES_FIELDS = gql`
  fragment projectAppointmentNotesFields on ProjectAppointmentNotesBlock {
    id
    number
    technicalReview {
      appointmentNotes
    }
  }
`;
